 

export default class ProfssionalPrivilege {

    Id: number | undefined;
    Title: string | undefined;
    Privilege: string | undefined;
    PrivilegeDescription: string | undefined;
    TasyCode: number | undefined;
    RemoveTasy: boolean | undefined;
    
    static NewInstance() {
        return new ProfssionalPrivilege();
    }
}